import React from 'react';
import { Page } from '../Page';
export function Page11() {
  return <Page pageNumber={33} variant="light" data-id="element-742" data-mp="2bh50frb3d9td">
      <div className="flex flex-col h-full" data-id="element-743" data-mp="5u455wmrmtt6">
        <div className="mb-6 pt-2" data-id="element-744" data-mp="5r84w1ng3t1k">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-2" data-id="element-745" data-mp="tgb1238pwuq">
            Looking Ahead
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-746" data-mp="3rzr7sm17wbg9">
            When Calories{' '}
            <span className="text-tealslate" data-id="element-747" data-mp="3n2hegvapjfn5">Start to Matter</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-748" data-mp="3i8wmbjvspfvv" />
        </div>

        <div className="mb-6 flex flex-col items-center justify-center py-4 border-y border-[#D8D8D0]" data-id="element-749" data-mp="3e8cm27fxdw5i">
          <div className="text-[72px] font-serif text-[#1F1F1F] leading-none tracking-tight mb-1" data-id="element-750" data-mp="39akniukrzbsc">
            5-15<span className="text-tealslate" data-id="element-751" data-mp="349n5qj3ogjrd">%</span>
          </div>
          <p className="text-sm font-bold text-tealslate uppercase tracking-[0.2em]" data-id="element-752" data-mp="2zblqyadab6lp">
            The Sustainable Deficit
          </p>
        </div>

        <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-6 max-w-2xl mx-auto text-center" data-id="element-753" data-mp="ujsu49pa73rc">
          For the first few months on GLP-1 medication, you likely won't need to
          count calories. The medication suppresses your appetite enough that
          focusing on protein, fiber, and hydration naturally creates a caloric
          deficit. But eventually, that may change.
        </p>

        <div className="grid grid-cols-3 gap-5 mb-6" data-id="element-754" data-mp="1dcem2ix2ia6n">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-755" data-mp="1iaoh8tislas9">
            <div className="text-tealslate font-serif text-2xl mb-1" data-id="element-756" data-mp="1i8vie0ef7uut">01</div>
            <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-757" data-mp="13d5svsa10zlc">
              Hitting a Plateau
            </h3>
            <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-758" data-mp="18ev8zmc3w3ga">
              As you lose weight, your body requires fewer calories to maintain
              its new, smaller size.
            </p>
          </div>
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-759" data-mp="1zkalb7stuj16">
            <div className="text-tealslate font-serif text-2xl mb-1" data-id="element-760" data-mp="1zjha9umu57d8">02</div>
            <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-761" data-mp="1umiihiqn9ci7">
              Medication Adaptation
            </h3>
            <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-762" data-mp="1psmoerdi49sb">
              Over time, your body adapts to the medication. Hunger cues will
              return.
            </p>
          </div>
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-763" data-mp="1fxmcdr85e9k8">
            <div className="text-tealslate font-serif text-2xl mb-1" data-id="element-764" data-mp="1btmyzhi5zqv3">03</div>
            <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-765" data-mp="16v3bhcnxa70m">
              Transitioning Off
            </h3>
            <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-766" data-mp="11xbi0e7mqcub">
              If you stop the medication, you must understand your baseline to
              prevent regain.
            </p>
          </div>
        </div>

        <div className="flex-1 flex flex-col" data-id="element-767" data-mp="2wb2s1etveyqa">
          <h2 className="text-xl font-serif text-[#1F1F1F] mb-3 text-center" data-id="element-768" data-mp="33uc0n5ujytea">
            How to Find Your Maintenance
          </h2>
          <div className="grid grid-cols-2 gap-5 mb-4" data-id="element-769" data-mp="38s3u44auinkl">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-770" data-mp="3djvj4aecsl8m">
              <h3 className="font-bold text-[#1F1F1F] text-xs mb-2" data-id="element-771" data-mp="3dknepl7yaiyw">
                Method 1: The Quick Math
              </h3>
              <p className="text-[11px] text-[#7A7A70] mb-2 leading-[1.6]" data-id="element-772" data-mp="2kv7wobhvbpth">
                Multiply your bodyweight (in lbs) by 14-18 depending on activity
                level.
              </p>
              <div className="bg-[#D8D8D0] p-2 text-center font-mono text-[10px] text-[#3B3B3B] leading-relaxed" data-id="element-773" data-mp="2utdvgk8dofu4">
                BW × 14 (Sedentary)
                <br data-id="element-774" data-mp="2zt8ooufmlhic" />
                BW × 16 (Moderate)
                <br data-id="element-775" data-mp="a3ezl94lxx7v" />
                BW × 18 (Active)
              </div>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-776" data-mp="f287mm14kw0n">
              <h3 className="font-bold text-[#1F1F1F] text-xs mb-2" data-id="element-777" data-mp="f4ci5mtj4t9w">
                Method 2: Guess & Check
              </h3>
              <p className="text-[11px] text-[#7A7A70] leading-[1.6]" data-id="element-778" data-mp="8m9bz5qsesdl">
                Track your daily calories and morning weight for 2 weeks. If
                your average weight stays the same, your average calorie intake
                is your maintenance.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-auto bg-tealslate text-white p-3 text-center font-bold text-sm" data-id="element-779" data-mp="vldwbqa4sh83">
          If maintenance is 2,000 calories, a sustainable 5-15% deficit =
          1,700-1,900 calories/day
        </div>
      </div>
    </Page>;
}